import produce from 'immer';
import {
  GET_PROMOTIONS_START,
  GET_PROMOTIONS_SUCCESS,
  GET_PROMOTIONS_FAILED,
  GET_SINGLE_PROMO_START,
  GET_SINGLE_PROMO_SUCCESS,
  GET_SINGLE_PROMO_FAILED,
  GET_SINGLE_TEMPLATE_START,
  GET_SINGLE_TEMPLATE_SUCCESS,
  GET_SINGLE_TEMPLATE_FAILED,
  GET_METADATA_START,
  GET_METADATA_SUCCESS,
  GET_METADATA_FAILED,
  GET_REQUESTED_CUSTOM_PROMOTIONS_START,
  GET_REQUESTED_CUSTOM_PROMOTIONS_SUCCESS,
  GET_REQUESTED_CUSTOM_PROMOTIONS_FAILED,
  SET_ACTIVE_TAB,
  CANCEL_PROMOTION_START,
  CANCEL_PROMOTION_FAILED,
  CANCEL_PROMOTION_SUCCESS,
  CREATE_PROMO_BY_TEMPLATE_START,
  CREATE_PROMO_BY_TEMPLATE_FAILED,
  CREATE_PROMO_BY_TEMPLATE_SUCCESS,
  RESCHEDULE_PROMOTION_START,
  RESCHEDULE_PROMOTION_SUCCESS,
  RESCHEDULE_PROMOTION_FAILED
} from '../actions/promo';


const initialState = {
  promoData: {
    Finished: {promotions: []},
    Published: {promotions: []},
    Started: {promotions: []}
  },
  loadingPromotionsList: [],
  loadingCanceledPromoList: [],
  requestedCustomPromotions: [],
  requestedCustomPromotionsCount: null,
  metadata: {
    'Discount types': [],
    Brands: [],
    Manufactures: [],
    'Listing type': [],
    Events: []
  },
  activeTab: 'all',
  promotionsLoading: false,
  browsePromoLoading: false,
  requestedCustomPromotionsLoading: false,
  libraryLoading: false,
  cancelInProgress: false,
  selectedPromo: {},
  loadingSinglePromo: false,
  error: false
};

const formReducer = produce((state: IPromoState = initialState, action) => {
  switch (action.type) {
    case GET_PROMOTIONS_START: {
      state.promotionsLoading = true;
      break;
    }
    case GET_PROMOTIONS_SUCCESS: {
      const {data = {}, status} = action;
      const {config = {}, promotions = []} = data;
      const promoWithDates = promotions.map((p) => {
        return {
          ...p,
          start: new Date(p.startDate),
          end: new Date(new Date(p.endDate).setHours(23, 59, 59)),
          usage: p.skus.length,
        };
      });
      state.promoData[status] = {config, promotions: promoWithDates};
      state.promotionsLoading = false;

      break;
    }
    case GET_PROMOTIONS_FAILED: {
      state.error = true;
      state.promotionsLoading = false;
      break;
    }

    case GET_SINGLE_PROMO_START: {
      state.loadingSinglePromo = true;
      break;
    }
    case GET_SINGLE_PROMO_SUCCESS: {
      const { promotion } = action.data;
      state.selectedPromo = promotion;
      state.loadingSinglePromo = false;
      break;
    }
    case GET_SINGLE_PROMO_FAILED: {
      state.error = true;
      state.loadingSinglePromo = false;
      break;
    }

    case GET_SINGLE_TEMPLATE_START: {
      state.loadingSinglePromo = true;
      break;
    }
    case GET_SINGLE_TEMPLATE_SUCCESS: {
      const { library } = action.data;
      state.selectedPromo = library;
      state.loadingSinglePromo = false;
      break;
    }
    case GET_SINGLE_TEMPLATE_FAILED: {
      state.error = true;
      state.loadingSinglePromo = false;
      break;
    }

    case CANCEL_PROMOTION_START: {
      const {id} = action;
      state.cancelInProgress = true;
      state.loadingCanceledPromoList = [...state.loadingCanceledPromoList, id];
      break;
    }
    case CANCEL_PROMOTION_SUCCESS: {
      const { promo } = action.data;
      state.promoData.Published.promotions = state.promoData.Published.promotions?.filter((p) => p._id !== promo._id);
      state.promoData.Started.promotions = state.promoData.Started.promotions?.filter((p) => p._id !== promo._id);
      state.cancelInProgress = false;
      state.loadingPromotionsList = state.loadingPromotionsList.filter((el) => el !== promo._id);

      break;
    }

    case CANCEL_PROMOTION_FAILED: {
      const {id} = action;

      state.loadingCanceledPromoList = state.loadingCanceledPromoList.filter((el) => el !== id);
      state.error = true;
      state.cancelInProgress = false;
      break;
    }

    case RESCHEDULE_PROMOTION_START: {
      const {id} = action;
      state.cancelInProgress = true;
      state.loadingCanceledPromoList = [...state.loadingCanceledPromoList, id];
      break;
    }

    case RESCHEDULE_PROMOTION_SUCCESS: {
      const { promotion } = action.data;

      state.promoData.Published.promotions = state.promoData.Published.promotions?.filter((p) => p._id !== promotion._id);
      state.promoData.Started.promotions = state.promoData.Started.promotions?.filter((p) => p._id !== promotion._id);

      state.promoData[promotion.status].promotions = [promotion, ...state.promoData[promotion.status].promotions];

      state.cancelInProgress = false;
      state.loadingCanceledPromoList = state.loadingCanceledPromoList.filter((el) => el !== promotion._id);

      break;
    }

    case RESCHEDULE_PROMOTION_FAILED: {
      const {id} = action;

      state.loadingCanceledPromoList = state.loadingCanceledPromoList.filter((el) => el !== id);
      state.error = true;
      state.cancelInProgress = false;
      break;
    }

    case GET_METADATA_START: {
      state.browsePromoLoading = true;
      break;
    }
    case GET_METADATA_SUCCESS: {
      const {labels} = action.data;
      state.metadata = labels;
      state.error = false;
      state.browsePromoLoading = false;

      break;
    }
    case GET_METADATA_FAILED: {
      state.error = true;
      state.browsePromoLoading = false;
      break;
    }

    case GET_REQUESTED_CUSTOM_PROMOTIONS_START: {
      state.requestedCustomPromotionsLoading = true;
      break;
    }
    case GET_REQUESTED_CUSTOM_PROMOTIONS_SUCCESS: {
      const { data, totalCount } = action.data;
      state.requestedCustomPromotions = data;
      state.requestedCustomPromotionsCount = totalCount;
      state.error = false;
      state.requestedCustomPromotionsLoading = false;

      break;
    }
    case GET_REQUESTED_CUSTOM_PROMOTIONS_FAILED: {
      state.error = true;
      state.requestedCustomPromotionsLoading = false;
      break;
    }

    case SET_ACTIVE_TAB: {
      const {data} = action;
      state.activeTab = data;

      break;
    }

    case CREATE_PROMO_BY_TEMPLATE_START: {
      const {id} = action;

      state.promotionsLoading = true;
      state.loadingPromotionsList = [...state.loadingPromotionsList, id];
      break;
    }
    case CREATE_PROMO_BY_TEMPLATE_SUCCESS: {
      state.promotionsLoading = false;
      const {data} = action;
      state.promoData[data.promotion.status].promotions = [data.promotion, ...state.promoData[data.promotion.status].promotions];
      state.loadingPromotionsList = state.loadingPromotionsList.filter((el) => el !== data.promotion.libraryId);
      break;
    }

    case CREATE_PROMO_BY_TEMPLATE_FAILED: {
      const {id} = action;

      state.loadingPromotionsList = state.loadingPromotionsList.filter((el) => el !== id);
      state.error = true;
      state.promotionsLoading = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
